import React, { FC, LazyExoticComponent, Suspense, useMemo } from "react";
import LoaderOverlay from "../../pages/Utilities/LoaderOverlay";
import DashboardSkeleton from "../../pages/Home/Skeleton/DashboardSkeleton";
import { useLocation } from "react-router-dom";

type T_SuspenseWrapperProps = {
  LazyLoadingComponent: LazyExoticComponent<React.FC<any>>;
  FallBackComponent?: React.FC<any> | null;
  componentProps?: any;
};

const SuspenseWrapper: FC<T_SuspenseWrapperProps> = ({
  LazyLoadingComponent,
  FallBackComponent = null,
  componentProps = {},
}) => {
  const { pathname } = useLocation();
  const getFallbackComponent = useMemo(() => {
    if (FallBackComponent) {
      return <FallBackComponent />;
    }
    const isHomeRoute = pathname === "/home";
    return isHomeRoute ? (
      <DashboardSkeleton />
    ) : (
      <LoaderOverlay
        zIndex={2999}
        heading={"We're getting things ready for you"}
      />
    );
  }, [FallBackComponent, pathname]);

  return (
    <Suspense fallback={getFallbackComponent}>
      <LazyLoadingComponent {...componentProps} />
    </Suspense>
  );
};
export default SuspenseWrapper;
